export default __webpack_public_path__ + "static/media/ArrowDown.2a3ed874.svg";